import React from 'react';
import { ProgressIndicator } from '@veneer/core';

export default class PageSpinner extends React.Component {
  render() {
    return (
      <div className='dui-page-spinner'>
        <ProgressIndicator color={'colorHpBlue6'} />
        {this.props.label && (
          <span className='spinner-label'>
            <p>{this.props.label}</p>
          </span>
        )}
      </div>
    );
  }
}
